import { useMemo } from 'react'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import { useLocalStorage } from './local-storage'
import { useCookies } from './use-cookies'

export const useBrowserState = () => {
  const localStorage = useLocalStorage()
  const params_ = useParams()
  const [searchParams] = useSearchParams()
  const routerLocation = useLocation()
  const cookies = useCookies()

  const location = useMemo(
    () => ({
      ...routerLocation,
      origin: window.location.origin,
      host: window.location.host,
    }),
    [routerLocation]
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const params = useMemo(() => params_, [JSON.stringify(params_)])

  return useMemo(
    () => ({
      localStorage,
      viewParams: params,
      urlSearchParams: Object.fromEntries(searchParams.entries()),
      location,
      cookies,
      environment: process.env,
    }),
    [localStorage, location, params, searchParams, cookies]
  )
}
